import { render, staticRenderFns } from "./ProductRestockQuantity.vue?vue&type=template&id=5ed69f9d&"
import script from "./ProductRestockQuantity.vue?vue&type=script&lang=ts&"
export * from "./ProductRestockQuantity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports